import request from '../utils/request'

export const createFormData = (data: any): FormData => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  return formData;
};

export const postFormData = (url: string) => (data: any) => 
  request({
    url,
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data: createFormData(data),
  });

export const post = (url: string) => (data: any) => 
  request({
    url,
    method: 'post',
    data,
  });

export const get = (url: string) => (params: any = {}) => 
  request({
    url,
    method: 'get',
    params,
  });

export const put = (url: string) => (data: any) =>
  request({
    url,
    method: 'put',
    data,
  });

export const putFormData = (url: string) => (data: any) =>
  request({
    url,
    method: 'put',
    headers: { "Content-Type": "multipart/form-data" },
    data: createFormData(data),
  });

export const del = (url: string) => (params: any = {}) => 
  request({
    url,
    method: 'delete',
    params,
  });
